// Orange design
const OrangeDesign = {
  id: 'orange',
  name: 'Orange',
  category: 'tech',
  description: 'Bold dynamic design with orange accents',
  colors: {
    primary: "#FF9900",    // Orange
    secondary: "#232F3E",  // Navy
    tertiary: "#146EB4",   // Blue
    quaternary: "#37475A", // Dark Gray
    accent1: "#FEBD69",    // Light Orange
    accent2: "#131921",    // Dark Navy
    accent3: "#00A8E1",    // Light Blue
    accent4: "#48A3C6",    // Teal
    accent5: "#4D5F6C",    // Medium Gray
    accent6: "#F3A847",    // Gold
    accent7: "#48A3C6",    // Teal
    accent8: "#007185",    // Dark Teal
    text: "#111111",       // Dark Text
    textSecondary: "#565959", // Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#F5F5F5", // Light gray background
    border: "#DDDDDD",     // border color
  },
};

export default OrangeDesign; 